<ng-container *transloco="let t; read: 'holiday'" >
    <h2 class="mbm">{{t('title')}}</h2>
    <kendo-grid
      [data]="holidays"
      (edit)="editHandler($event)"
      (cancel)="cancelHandler($event)"
      (save)="saveHandler($event)"
      (remove)="removeHandler($event)"
      (add)="addHandler($event)"
      [style.maxHeight.px]="600"
    >
      <ng-template kendoGridToolbarTemplate>
        <button kendoGridAddCommand>{{t('add')}}</button>
      </ng-template>
      <kendo-grid-column field="name" [title]="t('name')"> </kendo-grid-column>
      
      <kendo-grid-column field="start" [title]="t('start')">
        <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.start | date}}
          </ng-template>
          <ng-template
            kendoGridEditTemplate
            let-dataItem="dataItem"
            let-formGroup="formGroup"
            let-isNew="isNew"
          >
            <kendo-formfield>
              <kendo-datepicker
                [formControl]="formGroup.get('start')"
              ></kendo-datepicker>
              <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
            </kendo-formfield>
          </ng-template>
      </kendo-grid-column>
  

      <kendo-grid-column field="isAlwaysSameDate" [title]="t('isAlwaysSameDate')" editor="boolean" [width]="150"> 
        <ng-template kendoGridCellTemplate let-dataItem>
          {{dataItem.isAlwaysSameDate ? t('yes') : t('no')}}
        </ng-template>
        <ng-template 
          kendoGridEditTemplate 
          let-dataItem="dataItem"
          let-formGroup="formGroup"
          >
          <input 
            type="checkbox" 
            kendoCheckBox
            [value]="dataItem.isAlwaysSameDate"
            [formControl]="formGroup.get('isAlwaysSameDate')"
          />
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="isPreworked" [title]="t('isPreworked')" editor="boolean" [width]="150"> 
        <ng-template kendoGridCellTemplate let-dataItem>
          {{dataItem.isPreworked ? t('yes') : t('no')}}
        </ng-template>
        <ng-template 
          kendoGridEditTemplate 
          let-dataItem="dataItem"
          let-formGroup="formGroup"
          >
          <input 
            type="checkbox" 
            kendoCheckBox
            [value]="dataItem.isPreworked"
            [formControl]="formGroup.get('isPreworked')"
          />
        </ng-template>
      </kendo-grid-column>
    
    
      <kendo-grid-command-column
        [title]="t('action')"
        [width]="250"
    
      >
        <ng-template kendoGridCellTemplate let-isNew="isNew">
          <button kendoGridEditCommand themeColor="primary">{{t('edit')}}</button>
          <button kendoGridRemoveCommand>{{t('delete')}}</button>
          <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
            {{ isNew ? t('add') : t('save') }}
          </button>
          <button kendoGridCancelCommand>
            {{ isNew ? t('discard') : t('cancel') }}
          </button>
        </ng-template>
      </kendo-grid-command-column>

      <<ng-template kendoGridNoRecordsTemplate>
        {{t('noResults')}}
      </ng-template>
    </kendo-grid>

    <app-delete-confirm-dialog
      [(opened)]="deletionDialogOpened"
      [message]="t('deletionMessage')"
      (confirmed)="deleteConfirmed()"
    ></app-delete-confirm-dialog>
    
    
    
</ng-container>